import React from "react";
import "./configureKPI.css";
import KPIConfigTitleChange from "./KPIConfigTitleChange/KPIConfigTitleChange";
import KPIConfigDataPointLabelChange from "./KPIConfigDataPointLabelChange/KPIConfigDataPointLabelChange";
import KPIConfigDataSummaryButtonsSelect from "./KPIConfigDataSummaryButtonsSelect/KPIConfigDataSummaryButtonsSelect";
import KPIPreview from "./KPIPreview/KPIPreview";
import { InputFieldLengthValidationType } from "../../../../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKPIType";
interface ConfigureKPIProps {
  kpi: Record<string, any>;
  updateUserConfig: (_id: string, _kpi: Record<string, any>) => void;
  inputLengthValidation: InputFieldLengthValidationType;
  defaultConfigGlobal: Record<string, any>;
}
const ConfigureKPI: React.FC<ConfigureKPIProps> = ({
  kpi,
  updateUserConfig,
  inputLengthValidation,
  defaultConfigGlobal
}) => {
  return (
    <div className="kpi-config-container">
      <KPIConfigTitleChange
        kpi={kpi}
        updateUserConfig={updateUserConfig}
        inputDataValidation={{ maxLength: inputLengthValidation.max, minLength: inputLengthValidation.min }}
        defaultConfigGlobal={defaultConfigGlobal}
      />

      <KPIConfigDataPointLabelChange
        kpi={kpi}
        updateUserConfig={updateUserConfig}
        inputDataValidation={{ maxLength: inputLengthValidation.max, minLength: inputLengthValidation.min }}
        defaultConfigGlobal={defaultConfigGlobal}

      />
      {/* only render this if we have some buttons  */}
      <KPIConfigDataSummaryButtonsSelect
        kpi={kpi}
        updateUserConfig={updateUserConfig}
        defaultConfigGlobal={defaultConfigGlobal}
      />

      <KPIPreview kpi={kpi}
        defaultConfigGlobal={defaultConfigGlobal}
      />
    </div>
  );
};

export default ConfigureKPI;
